<header class="app-header">
  @let isAdmin = isAdmin$ | async;
  @let isAuthenticated = isAuthenticated$ | async;
  @let isSales = isSales$ | async;
  <nav class="app-nav">
    <div class="app-nav__inner">
      <a routerLink="/account/login" class="app-nav__brand">
        <img src="assets/shared/brand/WWC - Primary Logo - Black Orange.svg" alt="WWC logo" />
      </a>
      <div class="app-nav__links" id="navbar-default">
        <ul>
          <li *ngIf="isAdmin || isSales">
            <a routerLink="/sales">Sales</a>
          </li>
          <li *ngIf="isAdmin">
            <a routerLink="/administration">Administration</a>
          </li>
          <li *ngIf="isAuthenticated === false">
            <a routerLink="/account">Sign In</a>
          </li>
          <li *ngIf="isAuthenticated === true">
            <a routerLink="/account-settings">Account</a>
          </li>
          <li *ngIf="isAuthenticated === true">
            <a routerLink="/profile">My Profile</a>
          </li>
          <li *ngIf="isAuthenticated === true">
            <button type="button" class="button-quiet app-nav__action" (click)="logOut()">Sign Out</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
